import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=e0d61b10&scoped=true&"
import script from "./Measurement.vue?vue&type=script&lang=js&"
export * from "./Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Measurement.vue?vue&type=style&index=0&id=e0d61b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d61b10",
  null
  
)

export default component.exports